import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import service from './announcement.service'

const useAnnouncement = () => {
  const baseCrud = useCrud(API_RESOURCE.ANNOUNCEMENT, service)

  const queryClient = useQueryClient()

  const useFetchAnnouncementByType = (type) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.details(), type],
      queryFn: () => service.fetchAnnouncementByType(type),
    })
  }

  return {
    //Base CRUD
    useFetchAllAnnouncements: baseCrud.useFetchAll,
    useFetchAnnouncement: baseCrud.useFetchOne,
    useCreateAnnouncement: baseCrud.useCreate,
    useUpdateAnnouncement: baseCrud.useUpdate,
    useRemoveAnnouncement: baseCrud.useRemove,

    //Extra
    useFetchAnnouncementByType: useFetchAnnouncementByType,
  }
}

export default useAnnouncement
